// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3ckre","title":"AfterFrontImage_title__WabMz"};